import { MUI_X_5_COLUMN_MENU_CLASS } from '@dispatch/web/theme';
import { GRID_COLUMN_MENU_SLOT_PROPS } from '@mui/x-data-grid-pro';
import type { DataGridProProps } from '@mui/x-data-grid-pro';
import { ColumnMenu5Items, ColumnMenu5SortItems } from './ColumnMenu5Items';

export const MUI_X_5_GRID_PROPS: Pick<
  DataGridProProps,
  'localeText' | 'slotProps'
> = {
  localeText: {
    columnMenuHideColumn: 'Hide',
    columnMenuManageColumns: 'Show columns',
  },
  slotProps: {
    columnMenu: {
      className: MUI_X_5_COLUMN_MENU_CLASS,
      slots: {
        columnMenuSortItem: null,
        columnMenuFilterItem: null,
        columnMenuColumnsItem: ColumnMenu5Items,
      },
      slotProps: {
        columnMenuPinningItem: {
          displayOrder:
            GRID_COLUMN_MENU_SLOT_PROPS.columnMenuColumnsItem.displayOrder + 1,
        },
      },
    },
  },
};

// Without a column selector the grid drops the columns item, so sorting keeps
// its own slot.
export const MUI_X_5_GRID_PROPS_WITHOUT_COLUMN_SELECTOR: Pick<
  DataGridProProps,
  'localeText' | 'slotProps'
> = {
  localeText: MUI_X_5_GRID_PROPS.localeText,
  slotProps: {
    columnMenu: {
      className: MUI_X_5_COLUMN_MENU_CLASS,
      slots: { columnMenuSortItem: ColumnMenu5SortItems },
    },
  },
};
